<script setup lang="ts">
import { onMounted, onUnmounted, ref, computed } from 'vue';

import { uid } from '../../../../../resources/assets/js/utils';

import { Tooltip, TooltipOptions } from './tooltip';

export interface PhxsgTooltipProps {
  id?: string;
  options?: TooltipOptions;
  triggerAttrs?: Record<string, string>;
  contentAttrs?: Record<string, string>;
}

const { id = uid('tooltip'), options = {}, triggerAttrs = {}, contentAttrs = {} } = defineProps<PhxsgTooltipProps>();

const tooltipRef = ref<HTMLElement | null>(null);
const contentId = computed(() => `${id}-content`);
let tooltipInstance: Tooltip | null = null;

onMounted(() => {
  if (!tooltipRef.value) {
    return;
  }

  tooltipInstance = new Tooltip(tooltipRef.value, options);
});

onUnmounted(() => {
  tooltipInstance?.destroy();
  tooltipInstance = null;
});
</script>

<template>
  <div :id="id" ref="tooltipRef" class="phxsg-tooltip">
    <slot
      name="trigger"
      :trigger-class="'phxsg-tooltip__trigger'"
      :trigger-attrs="{
        ...triggerAttrs,
        'aria-describedby': contentId,
      }"
    />

    <div :id="contentId" class="phxsg-tooltip__content" role="tooltip" v-bind="contentAttrs">
      <div v-if="options?.enableArrow" class="phxsg-tooltip__arrow"></div>
      <slot name="content" />
    </div>
  </div>
</template>

<style src="./tooltip.css"></style>
